import React from 'react';
// import styles from './StaffMembers.module.scss';
import StaffMembersTable from "../../../components/StaffMembersTable/StaffMembersTable";


const ChainStaffMembers = (props) => {
    return(
        <div>
            <StaffMembersTable userType={3} />
        </div>
    )
}


export default ChainStaffMembers;
